import { atom } from 'recoil'

import { Me } from '../api'


export const meState = atom<Me>({
  key: 'meState',
  default: undefined,
})
